class BaseArea {
    constructor(data) {
        this.type = data.type;
    }
}

export default BaseArea;